/**
 * The path of the item whose prefix matches `pathname` most specifically, or
 * `undefined` when none matches.
 */
export const findSelectedPath = (
  items: ReadonlyArray<{ path: string; prefixes: ReadonlyArray<string> }>,
  pathname: string,
): string | undefined => {
  let selected: { path: string; length: number } | undefined;
  for (const item of items) {
    for (const prefix of item.prefixes) {
      if (!pathname.startsWith(prefix)) continue;
      if (!selected || prefix.length > selected.length) {
        selected = { path: item.path, length: prefix.length };
      }
    }
  }
  return selected?.path;
};
